/**
 * Rock Off Retail - PDP "Style" tabs: switching style must not grow history.
 *
 * The tabs (snippets/rockoff-style-tabs.liquid) are real <a href> links to
 * the sibling products of the SAME design (men's / women's / kids / white
 * version ...). A plain click used to push a history entry per tab, so the
 * Back button walked back through every style the shopper had tried before
 * returning to the collection/hub/search they came from (Mike, 1 Oct 2026).
 *
 * Fix: a plain left-click on a tab navigates with location.replace(), which
 * swaps the current history entry instead of adding one, so ONE Back returns
 * to where the shopper came from.
 *
 * The links stay real anchors (SEO, right-click, open in new tab). Anything
 * that is not a plain left-click is left to the browser untouched: ctrl /
 * cmd / shift / alt, middle or right button, a target other than _self, a
 * download link, another origin, or a click some other handler already
 * claimed (defaultPrevented).
 *
 * Colour within ONE product is a variant change: Dawn's product-info.js
 * updates ?variant= with history.replaceState (assets/product-info.js), so it
 * never pushes either.
 */
(function () {
  'use strict';

  if (window.__roStyleTabsReplace) return;
  window.__roStyleTabsReplace = true;

  var LINK_SELECTOR = '.ro-style-tabs a.ro-style-tabs__link[href]';

  function isPlainLeftClick(evt) {
    return (
      evt.button === 0 &&
      !evt.metaKey &&
      !evt.ctrlKey &&
      !evt.shiftKey &&
      !evt.altKey
    );
  }

  function onClick(evt) {
    if (evt.defaultPrevented || !isPlainLeftClick(evt)) return;
    var target = evt.target;
    if (!target || typeof target.closest !== 'function') return;
    var link = target.closest(LINK_SELECTOR);
    if (!link) return;

    var t = link.getAttribute('target');
    if (t && t !== '_self') return;
    if (link.hasAttribute('download')) return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    /* Same URL as now (e.g. a sibling pointing at this page): let the
       browser handle it as it normally would. */
    if (url.href === window.location.href) return;

    evt.preventDefault();
    window.location.replace(url.href);
  }

  document.addEventListener('click', onClick);
})();
